module.exports = __webpack_public_path__ + "img/7-5.d3717396.png";